import { useState } from "react";
import { Save, X, Percent, Hash, TrendingUp, TrendingDown } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money } from "../api";

const today = () => new Date().toISOString().slice(0, 10);

export default function PriceAdjustModal({ target, close, onSaved }) {
  const [mode, setMode] = useState("amount");
  const [newAmount, setNewAmount] = useState(target.current ?? "");
  const [percent, setPercent] = useState("");
  const [effectiveDate, setEffectiveDate] = useState(today());
  const [reason, setReason] = useState("");

  const cur = target.currency || "TRY";
  const old = Number(target.current) || 0;
  const preview = mode === "percent"
    ? Math.round(old * (1 + (Number(percent) || 0) / 100) * 100) / 100
    : Number(newAmount) || 0;
  const delta = preview - old;
  const pct = old ? Math.round((delta / old) * 1000) / 10 : 0;

  const submit = async (e) => {
    e.preventDefault();
    try {
      const body = { mode, effective_date: effectiveDate, reason: reason || null };
      if (mode === "percent") body.percent = Number(percent) || 0;
      else body.new_amount = Number(newAmount) || 0;
      await api.post(`/${target.kind}s/${target.id}/price-adjust`, body);
      toast.success("Fiyat farkı yansıtıldı");
      onSaved?.(); close();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="modal-backdrop" onClick={close}>
      <form className="modal" onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid="price-adjust-modal">
        <div className="modal-head">
          <div><span className="eyebrow">FİYAT FARKI YANSIT</span><h2>{target.name}</h2></div>
          <button type="button" onClick={close} data-testid="price-adjust-close"><X size={18} /></button>
        </div>

        <div className="mini-info" data-testid="price-adjust-current">Mevcut bedel: <b>{money(old, cur)}</b></div>

        <div className="dir-tabs">
          <button type="button" className={mode === "amount" ? "selected out" : ""} onClick={() => setMode("amount")} data-testid="price-mode-amount"><Hash size={14} /> Yeni Bedel</button>
          <button type="button" className={mode === "percent" ? "selected out" : ""} onClick={() => setMode("percent")} data-testid="price-mode-percent"><Percent size={14} /> Yüzde Fark</button>
        </div>

        <div className="form-grid">
          {mode === "amount" ? (
            <label>Yeni bedel ({cur})
              <input required type="number" step="0.01" min="0" value={newAmount} onFocus={(e) => e.target.select()} onChange={(e) => setNewAmount(e.target.value)} data-testid="price-adjust-amount-input" />
            </label>
          ) : (
            <label>Fark yüzdesi (%)
              <input required type="number" step="0.1" value={percent} onChange={(e) => setPercent(e.target.value)} placeholder="ör. 15 veya -10" data-testid="price-adjust-percent-input" />
            </label>
          )}
          <label>Geçerlilik tarihi
            <input type="date" value={effectiveDate} onChange={(e) => setEffectiveDate(e.target.value)} data-testid="price-adjust-date-input" />
          </label>
        </div>

        <label>Açıklama / gerekçe
          <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Fiyat farkı gerekçesi (enflasyon, kur, ek iş…)" data-testid="price-adjust-reason-input" />
        </label>

        <div className="pa-preview" data-testid="price-adjust-preview">
          <div><small>ESKİ</small><b>{money(old, cur)}</b></div>
          <div className="pa-arrow">→</div>
          <div><small>YENİ</small><b>{money(preview, cur)}</b></div>
          <div className={delta >= 0 ? "pa-delta up" : "pa-delta down"}>
            {delta >= 0 ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
            {delta >= 0 ? "+" : ""}{money(delta, cur)} ({pct >= 0 ? "+" : ""}{pct}%)
          </div>
        </div>

        <button className="new-btn full" data-testid="price-adjust-save"><Save size={15} /> Fiyat Farkını Uygula</button>
      </form>
    </div>
  );
}
